import client from "../client/client";

class ParagraphOutService {
  getParagraphsForDeliverables({ projectId, deliverableId, informationId }, cancelToken) {
    return client.get(
      `/spp/projects/${projectId}/coverage-document/${deliverableId}/information/${informationId}/coverage-paragraph/links`,
      {
        config: { cancelToken },
      }
    );
  }
  createParagraphForDeliverables(
    { projectId, deliverableId, informationId },
    { content, contentHTML, order_in_doc, page, title, paragraphId },
    cancelToken
  ) {
    return client.post(
      `/spp/projects/${projectId}/coverage-document/${deliverableId}/information/${informationId}/coverage-paragraph/links`,
      {
        payload: { content, contentHTML, order_in_doc, title, page, paragraphId },
        config: { cancelToken },
      }
    );
  }
  updateTitleForParagraphs({ projectId, deliverableId }, { title, ids }, cancelToken) {
    return client.put(`/spp/projects/${projectId}/coverage-document/${deliverableId}/coverage-paragraph`, {
      payload: { title, ids },
      config: { cancelToken },
    });
  }
  updateParagraph(
    { projectId, deliverableId, coverageParagraphId },
    { page, title, content, contentHTML, order_in_doc },
    cancelToken
  ) {
    return client.put(
      `/spp/projects/${projectId}/coverage-document/${deliverableId}/coverage-paragraph/${coverageParagraphId}`,
      {
        payload: {
          page,
          title,
          content,
          contentHTML,
          order_in_doc,
          coverageParagraphId,
        },
        config: { cancelToken },
      }
    );
  }
  deleteParagraphsLinkForDeliverables(
    { projectId, deliverableId, informationId, coverageParagraphId, linkId },
    cancelToken
  ) {
    return client.delete(
      `/spp/projects/${projectId}/coverage-document/${deliverableId}/information/${informationId}/coverage-paragraph/${coverageParagraphId}/links/${linkId}`,
      {
        config: { cancelToken },
      }
    );
  }
  deleteLinksNotPresentInDoc({ projectId, deliverableId }, { values }, cancelToken) {
    return client.patch(`/spp/projects/${projectId}/coverage-document/${deliverableId}/links`, {
      payload: { values },
      config: { cancelToken },
    });
  }
  getCountLinksNotPresentInDoc({ projectId, deliverableId }, { values }, cancelToken) {
    return client.post(`/spp/projects/${projectId}/coverage-document/${deliverableId}/links`, {
      payload: { values },
      config: { cancelToken },
    });
  }
  getIdsOfNoLongerExistingLinks({ projectId, deliverableId }, { values }, cancelToken) {
    return client.post(`/spp/projects/${projectId}/coverage-document/${deliverableId}/paragraphs`, {
      payload: { values },
      config: { cancelToken },
    });
  }
  transferLinksAndParagraphsToNewDeliv({ projectId, deliverableId }, { linksIds }, cancelToken) {
    return client.post(`/spp/projects/${projectId}/coverage-document/${deliverableId}/links/transfer`, {
      payload: { linksIds },
      config: { cancelToken },
    });
  }
}
export default new ParagraphOutService();
